<div class="col-8">
    <h4>Lista PC-003</h4>
</div>
<div class="col-12">
    <hr>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12 col-xl-12 col-sm-12 w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <div class="row">
                <div class="col-lg col-md text-right" style="align-self: center;">
                    <button mat-flat-button color="primary" class="btnSize" (click)="importCsv()"
                        matTooltip="Novo Registro" skipLocationChange>
                        <i class="fa fa-plus fa-1x btnIcon"></i>
                        Importar CSV
                    </button>
                    <button mat-flat-button color="primary" (click)="deleteMultiple()" class="btnSize"
                        [disabled]="!isRemoveEnable" matTooltip="Filtro Detalhado">
                        <i class="fa fa-remove fa-1x btnIcon"></i>
                        Remover
                    </button>
                    <button mat-flat-button color="primary" class="btnSize" (click)="new()" matTooltip="Novo Registro"
                        skipLocationChange>
                        <i class="fa fa-plus fa-1x btnIcon"></i>
                        Novo
                    </button>
                    <button mat-flat-button color="primary" (click)="showFilter()" class="btnSize"
                        matTooltip="Filtro Detalhado">
                        <i class="fa fa-filter fa-1x btnIcon"></i>
                        Filtro
                    </button>

                </div>
            </div>
            <br>

            <div class="table-responsive table-height ">
                <table mat-table [dataSource]="dataSource" matSort class="w-100">


                    <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef class="InputLabelHeaderColor formatField"> #
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            <mat-checkbox (change)="selectItens(row)"></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Hibrido">
                        <th mat-header-cell *matHeaderCellDef class="InputLabelHeaderColor formatField"> Híbrido
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            {{row.hibrido}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Safra">
                        <th mat-header-cell *matHeaderCellDef class="InputLabelHeaderColor formatField"> Safra
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            {{row.safra}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="PadraoPercentil">
                        <th mat-header-cell *matHeaderCellDef class="InputLabelHeaderColor formatField"> Padrao Percentil
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            {{row.padrao_percentil}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="UmidadeMaxima">
                        <th mat-header-cell *matHeaderCellDef class="InputLabelHeaderColor formatField"> Umidade Maxima
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            {{row.umidade_maxima}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Ações">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="InputLabelHeaderColor formatField">
                            Ações
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            <div>
                                <span>
                                    <button mat-flat-button color="primary" class="mr-1 mt-2 btnSize"
                                        matTooltip="Editar Registro" (click)="edit(row.id)"
                                        skipLocationChange>
                                        <i class="fa fa-edit fa-1x btnIcon"></i>
                                        Editar
                                    </button>
                                </span>
                                <button mat-flat-button color="warn" class="mr-1 mt-2 btnSize"
                                    matTooltip="Excluír Registro" (click)="delete(row.id)" skipLocationChange>
                                    <i class="fa fa-delete fa-1x btnIcon"></i>
                                    Excluír
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" colspan="100%"><i
                                class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum registro
                            encontrado</td>
                    </tr>
                </table>
                <div class="flipped">
                    <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
                </div>


            </div>
        </mat-card>
    </div>
</div>

<app-filter-detail>
    <app-form-humidity-filter (filter)="getFilter($event)"></app-form-humidity-filter>
</app-filter-detail>
